<app-page-header routerLink="/school/list" origin="Scholen" title="Gebruikers"></app-page-header>

<div class="row">
    <!-- <div class="card-header d-flex justify-content-between">
        <h5 class="card-title">Gebruikers</h5>
        <div class="card-buttons">
            <button (click)="openModal()" class="btn btn-primary">Toevoegen</button>
        </div>
    </div> -->
    <div class="card-body">
        <app-table-guru [showActionButton]="true" (actionButtonClicked)="openModal()" [actionButtonText]="'Toevoegen'" [apiEndpoint]="'/office/users'" [columnMapping]="[
            { key: 'name', label: 'Naam' },
            { key: 'email', label: 'Email', type: 'email' },
            { key: 'role.name', label: 'Rol' },
            { key: 'organisation.name', label: 'School' }
          ]" [itemsPerPage]="10" [viewURL]="'/user/details/'" [openModalComponent]="editFormReference"
            [reload]="reloadItems">
        </app-table-guru>
    </div>
</div>

<ng-template #content let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="modal-basic-title">Nieuwe gebruiker</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x"
                viewBox="0 0 16 16">
                <path
                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
            </svg>
        </button>
    </div>
    <div class="modal-body">
        <app-user-information-form [itemId]="''"></app-user-information-form>
    </div>
</ng-template>